var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popover-wrapper"},[_c('div',{staticClass:"trigger",class:{
            'icon-info-filled': _vm.styleFilled,
            'icon-info-outline': !_vm.styleFilled},on:{"click":function($event){$event.stopPropagation();}}})])}
var staticRenderFns = []

export { render, staticRenderFns }